module.exports = __webpack_public_path__ + "img/aigujia.0a25e5d0.png";